import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { MenuSvg } from './svgs';

export const IconMenu: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={MenuSvg} viewBox="0 0 24 24" {...props} />;
};
